"use strict";

import Vue from 'vue';
import axios from "axios";
import {Loading } from 'element-ui'; // Message
import CookieHelper from '@/plugins/cookie.js';
import codeMsg from '@/common-data/errorCode'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// console.log("process.env", process.env)
let config = {
  baseURL: process.env.VUE_APP_BASE_URL || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);
let loadingInstance = null
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    !config.silence && (loadingInstance = Loading.service({ fullscreen: true, background: 'rgba(0, 0, 0, 0.8)' }));

    if(config.url.indexOf("uploadPic") > -1) {
      let formData = new FormData();
      formData.append("uploadFile", config.data);
      config.data = formData
    }


    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // 不需要Message弹窗的接口
    const noNeedMessage = ['/abroad-admin-war/cms/ekyc2/h5/verifyOtp', '/abroad-admin-war/cms/ekyc2/h5/sendOtp']
    const noNeedMessageErrorCode = ['ekyc2.not.allow.op.within.applystatus']; 
    const { success, errorCode, msg } = response.data
    const { url, silence } = response.config
    // const userAgent = navigator.userAgent.toLowerCase();
    if (!success && !noNeedMessage.includes(url) && !noNeedMessageErrorCode.includes(errorCode) && !(url === '/abroad-admin-war/cms/ekyc2/h5/login' && (errorCode == 'ekyc2.otp.account.disable.minute' || errorCode == 'ekyc2.otp.account.disable.second'))) {
      const message = codeMsg[errorCode] ? typeof codeMsg[errorCode] == 'function' ? codeMsg[errorCode](msg) : codeMsg[errorCode] : msg
      const body = document.body
      body.style.height = '100%'
      body.style.overflow = 'hidden'
      window.$confirm({
        tip: true,
        mesg: message,
      }).then(() => {
        const body = document.body
        body.style.height = '100%'
        body.style.overflow = 'auto'
      })
    }
    // token 过期处理
    if (errorCode == 'ekyc2.invalid.token.error' || errorCode == 'ekyc2.not.allow.op.within.applystatus') {
      const { origin, pathname } = window.location
      window.location.href = `${origin + pathname}#/check-mid-process`
      CookieHelper.removeItem('token')
    }
    // Do something with response data

    // if(response.data && !response.data.result) {
    //   // 改 2021-05-08
    //   if (response.config.data && (typeof response.config.data) === 'string' && response.config.data.startsWith(`{"pageNo":"22","processNo":"1-3"`)) {
    //     // 1-3流程 第22步 需要特殊处理 忽略错误提示
    //   } else {
    //     Message.error(response.data ? response.data.errorInfo : "网络异常");
    //   }
    // }

    !silence && loadingInstance && loadingInstance.close();
    
    return response.data;
  },
  function(error) {
    // Do something with response error
    loadingInstance && loadingInstance.close();
    return Promise.reject(error);

  }
);

// eslint-disable-next-line
Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
